module.exports = __webpack_public_path__ + "img/_ionicons_svg_ios-close.caa97e03.svg";